import { Component, OnInit, Input } from "@angular/core";
import {
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../environments/environment";
import { ApplicationService } from "app/services/application.service";
import { PopupService } from "../../../services/shared/popup.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { PermitService } from "app/services/permit.service";
import { VehicleService } from "app/services/vehicle.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

@Component({
  selector: "motivation-viewer",
  templateUrl: "./motivation-viewer.component.html",
  styleUrls: ["./motivation-viewer.component.css"],
})
export class MotivationViewerComponent implements OnInit {
  @Input() dataCntrl: any;
  @Input() routeDetials: any;
  form: FormGroup;
  model: any = [];
  tabload: boolean = false;
  public pageload = false;
  disableBtn: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private toastService: ToastNotificationService,
    private showModal: PopupService,
    public applicationService: ApplicationService,
    private router: Router,
    private permitService: PermitService,
    private vehicleService: VehicleService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.router.url.indexOf("edit") > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params["id"];
        if (
          environment.authWebApi.userData.Roles.find((p) => p.Code == "ADMIN")
        ) {
          this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
    }
    this.initForm();
    this.model = this.dataCntrl;
  }

  initForm() {
    this.form = this.formBuilder.group({
      motivation: ["", [<any>Validators.required]],
    });
  }

  changes() {
    this.form.statusChanges.subscribe((result) => {
      this.dataCntrl.formValid = result == "VALID" ? true : false;
    });
  }
  saveMotivation() {
    this.pageload = true;
    this.tabload = true;
    if (this.dataCntrl.application.id == undefined) {
      //this.saveApplication();
    } else {
      this.applicationService
        .putApplication(this.dataCntrl.application)
        .subscribe(
          (result) => {
            this.pageload = false;
            this.dataCntrl.application = result;
            this.tabload = false;
            this.toastService.success(
              "Save Application",
              "Motivation saved successfully"
            );
            this.applicationService.setTab(5);
          },
          (error) => {
            //console.log(error)
            this.tabload = false;
            // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
            this.toastService.error(
              "Failed to save application. If the problem persist, please contact system administrator.",
              "Save Application"
            );
            return;
          }
        );
    }
  }
  backtoRoutes() {
    this.applicationService.setTab(3);
  }
  cancelApplication() {
    if (
      this.dataCntrl.application.id == undefined &&
      this.dataCntrl.application.id == null
    ) {
      this.router.navigate([
        "/carrier/permit/application/" + this.dataCntrl.carrierID,
      ]);
    } else {
      this.showModal
        .showConfirm(
          "Delete Application",
          "Are you sure you want to delete?",
          `You're about to delete application`,
          "Yes",
          "No"
        )
        .subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.deleteApplication();
          } else {
            return;
          }
        });
    }
  }
  deleteApplication() {
    //console.log("delete application");
    this.pageload = true;

    this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe((x) => {
      //console.log(x);
      this.deleteApp(this.dataCntrl.application.id);
      this.pageload = false;

      this.router.navigate([
        "/carrier/permit/application/" + this.dataCntrl.carrierID,
      ]);
    });
    //this.dataCntrl.application.id
    //this.dataCntrl.permit.id
  }
  deletePermit(id) {
    this.permitService.deletePermit(id).subscribe((x) => {
      //console.log(x);
    });
  }
  deleteApp(id) {
    this.applicationService.deleteApplication(id).subscribe((x) => {
      //console.log(x);
    });
  }
}
